import { Permissions } from 'reducers/root.reducer';

import {
  propertyManagerRolePermission,
  propertyOwnerRolePermission,
} from '../RMS/utils/permissions';

export const salesChannelPermissions: Permissions = [
  'Owner',
  'ManagedOwner',
  'FlipdishStaff',
  ...propertyManagerRolePermission,
  ...propertyOwnerRolePermission,
];
